module.exports = __webpack_public_path__ + "static/media/stockhausen_augen_5.a7fe1749.jpg";